import { ModalBody as CModalBody, ModalBodyProps } from '@chakra-ui/react';

const ModalBody = (props: ModalBodyProps) => {
  return (
    <CModalBody paddingBottom={5} paddingTop={4} paddingX={8} {...props} />
  );
};

export default ModalBody;
